import { Deserializer } from 'jsonapi-serializer';
import { JsonApiResponse } from 'types/store/jsonApi';
import { TasksMetrics } from 'types/store/projectTasksList';
import { TaskListFilters } from 'types/store/tasksList';

export interface FetchTasksMetricsUrlParams {
  projectId?: string;
  filters?: TaskListFilters;
  exportState?: {
    selectAll: boolean;
    excludedIds: string[];
    selectedIds: string[];
  };
}

export const getTasksMetricsUrl: (
  params: FetchTasksMetricsUrlParams
) => string = (params) => {
  const baseUrl = `/v3/projects/${params.projectId}/tasks-metrics`;
  const urlParams = new URLSearchParams();

  if (params.filters) {
    Object.entries(params.filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          urlParams.append(`filters[${key}][]`, v);
        });
      } else {
        if (value) {
          urlParams.append(`filters[${key}]`, value.toString());
        }
      }
    });
  }

  if (params.exportState) {
    if (params.exportState.selectAll) {
      urlParams.append('selectAll', params.exportState.selectAll.toString());
    }
    if (
      params.exportState.excludedIds &&
      params.exportState.excludedIds.length > 0
    ) {
      params.exportState.excludedIds.forEach((id) => {
        urlParams.append('excludedIds[]', id);
      });
    }
    if (
      params.exportState.selectedIds &&
      params.exportState.selectedIds.length > 0
    ) {
      params.exportState.selectedIds.forEach((id) => {
        urlParams.append('selectedIds[]', id);
      });
    }
  }
  return `${baseUrl}?${urlParams.toString()}`;
};

export const deserializeTasksMetrics: (
  response: JsonApiResponse<{
    editableTasksCount: number;
  }>
) => Promise<TasksMetrics> = async (response) => {
  const deserializer = new Deserializer({
    keyForAttribute: 'camelCase',
    transform: (record: { editableTasksCount: number }) => {
      return {
        editableCount: record.editableTasksCount,
      };
    },
  });
  return await deserializer.deserialize(response);
};
